import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayRemoveFalsyValues',
})
export class ArrayRemoveFalsyValuesPipe implements PipeTransform {
  transform(list: any[], property?: string): any[] {
    if (!list) {
      return [];
    }

    if (!property) {
      return list.filter((x) => !!x);
    }

    // Stringify the value to prevent false evaluation, especially when it's numeric and equals 0.
    return list.filter((x) => !!x[property]?.toString());
  }
}
